import { useMemo } from 'react'
import { useDynamicConfig } from '@statsig/react-bindings'
import { DynamicConfigName } from 'lib/statsig/feature_gates'
import { useAuthContext } from 'components/auth'

/**
 * This function is used to check if a company is whitelisted for a particular
 * dynamic config
 * The config needs to be set up in this format:
 * {companyIds: ['3', '4', '5'], companyGroupIds: ['6'], useWhitelist: true}
 * @param configName Name of the statsig dynamic config
 */
export function useIsCompanyWhitelisted(configName: DynamicConfigName) {
  const config = useDynamicConfig(configName)
  const { company } = useAuthContext()

  return useMemo(() => {
    if (!company) {
      return false
    }
    if (!config.get('useWhitelist', false)) {
      return false
    }
    const { id, companyGroup } = company
    const companyGroupId = companyGroup?.id
    const companyIds = config.get('companyIds', []).map(String)
    const companyGroupIds = config.get('companyGroupIds', []).map(String)

    return (
      (id && companyIds.includes(id.toString())) ||
      (companyGroupId && companyGroupIds.includes(companyGroupId.toString()))
    )
  }, [company, config])
}
